import { render, staticRenderFns } from "./BannerElement.vue?vue&type=template&id=75536087&"
import script from "./BannerElement.vue?vue&type=script&lang=js&"
export * from "./BannerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports